import { createFileRoute } from "@tanstack/react-router";
import { CarDetailsLegacyRedirect } from "@/pages/legacy/LegacyRedirects";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/cars/details/$id/")({
  head: ({ params }) => {
    const base = routeHead("/cars/details/$id/", params as Record<string, string>);
    return { ...base, meta: [...base.meta, { property: "og:type", content: "product" }] };
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <CarDetailsLegacyRedirect />
  );
}
